import 'simplebar'

import ResizeObserver from 'resize-observer-polyfill'
window.ResizeObserver = ResizeObserver
